// Lightweight i18n for Nidhi Fabrication (English / Hindi / Marathi)
export const LANGS = [
  { code: "en", label: "EN" },
  { code: "hi", label: "हिं" },
  { code: "mr", label: "मरा" },
];

export const translations = {
  en: {
    nav: { services: "Services", capabilities: "Capabilities", portfolio: "Portfolio", quality: "Quality", contact: "Contact" },
    brandSub: "STEEL · STRUCTURES · VIDARBHA",
    cta: { whatsapp: "WhatsApp", rapidQuote: "Rapid Quote", requestEstimation: "Request Project Estimation", viewProjects: "View Completed Projects", whatsappUs: "WhatsApp Us" },
    labels: { services: "Core Services", capabilities: "Workshop & Machinery", portfolio: "Project Showcase", quote: "Rapid Quote & RFQ", trust: "Local Presence & Trust" },
    hero: {
      eyebrow: "Heavy Engineering · Est. 2010",
      madeInIndia: "Proudly Made in India",
      lines: ["Heavy &", "Structural Metal", "Fabrication", "Across Vidarbha"],
      tagline: "Strong Steel · Foundations of Trust",
      sub: "Turnkey Pre-Engineered Buildings (PEB), industrial sheds, pressure vessels, storage tanks, and custom sheet-metal solutions — built to IS standards.",
      live: "// NAGPUR WORKSHOP · LIVE",
      scroll: "SCROLL",
    },
    metrics: ["Years Experience", "Projects Delivered", "& MSME Certified", "Compliant"],
    services: {
      heading: ["From single brackets to", "50-tonne", "structures"],
      sub: "Four integrated divisions under one MIDC roof — engineered, welded and dispatched to spec.",
      items: [
        { title: "Industrial & PEB Sheds", desc: "Turnkey factory sheds and logistics warehouses engineered for MIDC zones — from foundation bolts to roofing sheets.", tags: ["Factory Sheds", "PEB", "Warehouses"] },
        { title: "Heavy Industrial Fabrication", desc: "Storage tanks, silos, hoppers and code-compliant pressure vessels fabricated to IS standards.", tags: ["Tanks", "Silos", "Pressure Vessels"] },
        { title: "Agri & Agro-Processing", desc: "Cotton ginning chutes, conveyor systems and grain storage structures for Vidarbha's agri belt.", tags: ["Ginning Chutes", "Conveyors", "Grain Storage"] },
        { title: "Commercial & Laser Cutting", desc: "Mezzanine floors, structural staircases and precision CNC laser cutting job-work with tight tolerances.", tags: ["Mezzanines", "Staircases", "CNC Laser"] },
      ],
    },
    machinery: {
      heading: ["Capacity that handles the", "heavy jobs"],
      sub: "22,000 sq ft covered shop floor · IS-certified processes · in-house QA",
      items: [
        { name: "CNC Fiber Laser Cutting", detail: "High-speed precision cutting up to 25mm MS plate" },
        { name: "4-Roll Heavy Plate Bending", detail: "Hydraulic rolling of shells & cones up to 3m width" },
        { name: "MIG / TIG / SMAW Welding", detail: "Certified welders across all process stations" },
        { name: "Overhead EOT Cranes", detail: "Twin-girder handling for heavy assemblies" },
      ],
    },
    gallery: {
      heading: ["Delivered across", "Vidarbha"],
      tabs: { all: "All", sheds: "Industrial Sheds", tanks: "Storage Tanks", commercial: "Commercial" },
      actualWork: "Actual Work",
      titles: {
        101: "Steel Roofing Truss Structure", 102: "Rooftop Shed - On-Site Erection", 103: "Terrace Shed & Aluminium Glazing",
        104: "Custom MS Steel Benches", 105: "Stainless Steel Window Grille", 1: "PEB Factory Shed", 2: "SS Storage Tank Farm",
        3: "CNC Laser Job Work", 4: "Logistics Warehouse", 5: "Cement Silo Cluster", 6: "Structural Staircase",
        7: "Pressure Vessel Unit", 8: "Mezzanine Floor",
      },
    },
    quote: {
      heading: ["Get a rapid", "estimation"],
      sub: "Share your drawings or requirements. Our estimators respond with tonnage, timeline and transparent pricing in ₹ (per kg / per sq ft) — typically within one working day.",
      contact: { call: "Call / WhatsApp", email: "Email", workshop: "Workshop" },
      fields: { name: "Full Name *", company: "Company Name", phone: "Phone Number *", location: "Project Location / MIDC", service: "Service Type", estimate: "Est. Tonnage / Area (sq ft)", drawing: "Engineering Drawings (CAD / PDF)", message: "Message" },
      ph: { name: "Rajesh Deshmukh", company: "Vidarbha Agro Pvt. Ltd.", phone: "76662 88210", location: "Butibori MIDC, Nagpur", estimate: "e.g. 45 Tonnes / 12,000 sq ft", upload: "Click to upload drawing (max 25MB)", message: "Describe your project scope, steel grade, delivery timeline..." },
      services: ["Industrial Shed", "PEB", "Heavy Vessel", "Laser Cutting", "Other"],
      submit: "Submit RFQ for Instant Review",
      submitting: "Submitting...",
      errRequired: "Name and phone number are required.",
      okToast: "RFQ submitted — our engineering team will review it shortly.",
      errToast: "Something went wrong. Please try again or WhatsApp us.",
      successTitle: "RFQ Received",
      successBody: (n, p) => `Thank you, ${n}. Our engineering team is reviewing your request and will reach out on ${p}.`,
      another: "Submit Another",
    },
    trust: {
      heading: ["Trusted by plant managers", "across the belt"],
      coverage: "Service Coverage",
      coverageNote: "// Dispatch & on-site erection teams available district-wide across Vidarbha.",
      mapPin: "Dalda Company Chowk · Nagpur HQ",
      madeInIndia: "Made in India",
      since: "Serving Vidarbha since 2010",
      pricing: "Transparent ₹/kg & ₹/sq ft estimates",
      testimonials: [
        { role: "Plant Manager, Agro Processing Unit", quote: "Nidhi delivered our storage silo cluster three weeks ahead of schedule. The welding quality passed our third-party inspection on the first pass." },
        { role: "Infrastructure Contractor", quote: "We've handed them four PEB sheds now. IS-compliant drawings, honest tonnage estimates, and cranes on site when they say. Rare in this region." },
        { role: "Director, Logistics Warehousing", quote: "The 12kW laser job-work turnaround is genuinely fast. Complex brackets cut to spec, no rework. They've become our default fabricator." },
      ],
    },
    footer: {
      desc: "Heavy & structural metal fabrication built to IS standards. Serving industrial, agri and commercial clients across Nagpur, Chandrapur, Amravati, Wardha & Yavatmal.",
      quickWhatsapp: "Quick WhatsApp Inquiry",
      navigate: "Navigate",
      workshop: "Workshop",
      links: { services: "Services", capabilities: "Capabilities", portfolio: "Portfolio", quality: "Quality Standards", quote: "Get a Quote" },
      rights: "All rights reserved.",
    },
  },

  hi: {
    nav: { services: "सेवाएं", capabilities: "क्षमताएं", portfolio: "पोर्टफोलियो", quality: "गुणवत्ता", contact: "संपर्क" },
    brandSub: "स्टील · संरचनाएं · विदर्भ",
    cta: { whatsapp: "WhatsApp", rapidQuote: "त्वरित कोटेशन", requestEstimation: "प्रोजेक्ट अनुमान प्राप्त करें", viewProjects: "पूर्ण प्रोजेक्ट देखें", whatsappUs: "WhatsApp करें" },
    labels: { services: "मुख्य सेवाएं", capabilities: "कार्यशाला और मशीनरी", portfolio: "पूर्ण प्रोजेक्ट", quote: "त्वरित कोटेशन और RFQ", trust: "स्थानीय उपस्थिति और भरोसा" },
    hero: {
      eyebrow: "भारी इंजीनियरिंग · स्थापना 2010",
      madeInIndia: "गर्व से भारत में निर्मित",
      lines: ["भारी एवं", "संरचनात्मक धातु", "फैब्रिकेशन", "पूरे विदर्भ में"],
      tagline: "मजबूत स्टील · भरोसे का निर्माण",
      sub: "टर्नकी प्री-इंजीनियर्ड बिल्डिंग (PEB), औद्योगिक शेड, प्रेशर वेसल, स्टोरेज टैंक और कस्टम शीट-मेटल समाधान — IS मानकों के अनुसार निर्मित।",
      live: "// नागपुर कार्यशाला · लाइव",
      scroll: "स्क्रॉल",
    },
    metrics: ["वर्षों का अनुभव", "प्रोजेक्ट पूर्ण", "& MSME प्रमाणित", "अनुरूप"],
    services: {
      heading: ["एक ब्रैकेट से लेकर", "50-टन", "संरचनाओं तक"],
      sub: "एक ही MIDC छत के नीचे चार एकीकृत विभाग — डिज़ाइन, वेल्डिंग और स्पेक अनुसार डिस्पैच।",
      items: [
        { title: "औद्योगिक और PEB शेड", desc: "MIDC ज़ोन के लिए टर्नकी फैक्ट्री शेड और लॉजिस्टिक्स वेयरहाउस — फाउंडेशन बोल्ट से लेकर रूफिंग शीट तक।", tags: ["फैक्ट्री शेड", "PEB", "वेयरहाउस"] },
        { title: "भारी औद्योगिक फैब्रिकेशन", desc: "स्टोरेज टैंक, साइलो, हॉपर और IS मानकों के अनुरूप प्रेशर वेसल।", tags: ["टैंक", "साइलो", "प्रेशर वेसल"] },
        { title: "कृषि और एग्रो-प्रोसेसिंग", desc: "कपास जिनिंग च्यूट, कन्वेयर सिस्टम और विदर्भ के कृषि क्षेत्र के लिए अनाज भंडारण संरचनाएं।", tags: ["जिनिंग च्यूट", "कन्वेयर", "अनाज भंडारण"] },
        { title: "कमर्शियल और लेज़र कटिंग", desc: "मेज़ानाइन फ्लोर, संरचनात्मक सीढ़ियां और सटीक CNC लेज़र कटिंग जॉब-वर्क।", tags: ["मेज़ानाइन", "सीढ़ियां", "CNC लेज़र"] },
      ],
    },
    machinery: {
      heading: ["ऐसी क्षमता जो संभाले", "भारी काम"],
      sub: "22,000 वर्ग फुट कवर्ड शॉप फ्लोर · IS-प्रमाणित प्रक्रियाएं · इन-हाउस QA",
      items: [
        { name: "CNC फाइबर लेज़र कटिंग", detail: "25mm MS प्लेट तक हाई-स्पीड सटीक कटिंग" },
        { name: "4-रोल हेवी प्लेट बेंडिंग", detail: "3m चौड़ाई तक शेल और कोन की हाइड्रोलिक रोलिंग" },
        { name: "MIG / TIG / SMAW वेल्डिंग", detail: "सभी प्रोसेस स्टेशनों पर प्रमाणित वेल्डर" },
        { name: "ओवरहेड EOT क्रेन", detail: "भारी असेंबली के लिए ट्विन-गर्डर हैंडलिंग" },
      ],
    },
    gallery: {
      heading: ["पूरे विदर्भ में", "पूर्ण"],
      tabs: { all: "सभी", sheds: "औद्योगिक शेड", tanks: "स्टोरेज टैंक", commercial: "कमर्शियल" },
      actualWork: "वास्तविक कार्य",
      titles: {
        101: "स्टील रूफिंग ट्रस संरचना", 102: "रूफटॉप शेड - साइट पर निर्माण", 103: "टेरेस शेड और एल्युमिनियम ग्लेज़िंग",
        104: "कस्टम MS स्टील बेंच", 105: "स्टेनलेस स्टील विंडो ग्रिल", 1: "PEB फैक्ट्री शेड", 2: "SS स्टोरेज टैंक फार्म",
        3: "CNC लेज़र जॉब-वर्क", 4: "लॉजिस्टिक्स वेयरहाउस", 5: "सीमेंट साइलो क्लस्टर", 6: "संरचनात्मक सीढ़ी",
        7: "प्रेशर वेसल यूनिट", 8: "मेज़ानाइन फ्लोर",
      },
    },
    quote: {
      heading: ["पाएं त्वरित", "अनुमान"],
      sub: "अपने ड्रॉइंग या आवश्यकताएं साझा करें। हमारे अनुमानक टनेज, समयसीमा और ₹ में पारदर्शी मूल्य (प्रति किलो / प्रति वर्ग फुट) के साथ जवाब देते हैं — आमतौर पर एक कार्यदिवस के भीतर।",
      contact: { call: "कॉल / WhatsApp", email: "ईमेल", workshop: "कार्यशाला" },
      fields: { name: "पूरा नाम *", company: "कंपनी का नाम", phone: "फ़ोन नंबर *", location: "प्रोजेक्ट स्थान / MIDC", service: "सेवा प्रकार", estimate: "अनुमानित टनेज / क्षेत्रफल (वर्ग फुट)", drawing: "इंजीनियरिंग ड्रॉइंग (CAD / PDF)", message: "संदेश" },
      ph: { name: "राजेश देशमुख", company: "विदर्भ एग्रो प्रा. लि.", phone: "76662 88210", location: "बुटीबोरी MIDC, नागपुर", estimate: "उदा. 45 टन / 12,000 वर्ग फुट", upload: "ड्रॉइंग अपलोड करें (अधिकतम 25MB)", message: "अपने प्रोजेक्ट का दायरा, स्टील ग्रेड, डिलीवरी समयसीमा बताएं..." },
      services: ["औद्योगिक शेड", "PEB", "हेवी वेसल", "लेज़र कटिंग", "अन्य"],
      submit: "तुरंत समीक्षा हेतु RFQ भेजें",
      submitting: "भेजा जा रहा है...",
      errRequired: "नाम और फ़ोन नंबर आवश्यक हैं।",
      okToast: "RFQ भेजा गया — हमारी इंजीनियरिंग टीम शीघ्र ही समीक्षा करेगी।",
      errToast: "कुछ गड़बड़ हुई। कृपया पुनः प्रयास करें या WhatsApp करें।",
      successTitle: "RFQ प्राप्त हुआ",
      successBody: (n, p) => `धन्यवाद, ${n}। हमारी इंजीनियरिंग टीम आपके अनुरोध की समीक्षा कर रही है और ${p} पर संपर्क करेगी।`,
      another: "एक और भेजें",
    },
    trust: {
      heading: ["प्लांट मैनेजरों का भरोसा", "पूरे क्षेत्र में"],
      coverage: "सेवा क्षेत्र",
      coverageNote: "// विदर्भ के सभी ज़िलों में डिस्पैच और साइट पर निर्माण टीमें उपलब्ध।",
      mapPin: "डालडा कंपनी चौक · नागपुर मुख्यालय",
      madeInIndia: "भारत में निर्मित",
      since: "2010 से विदर्भ की सेवा में",
      pricing: "पारदर्शी ₹/किलो और ₹/वर्ग फुट अनुमान",
      testimonials: [
        { role: "प्लांट मैनेजर, एग्रो प्रोसेसिंग यूनिट", quote: "निधि ने हमारा स्टोरेज साइलो क्लस्टर तय समय से तीन सप्ताह पहले पूरा किया। वेल्डिंग गुणवत्ता पहली ही थर्ड-पार्टी जांच में पास हुई।" },
        { role: "इंफ्रास्ट्रक्चर ठेकेदार", quote: "हमने उन्हें अब तक चार PEB शेड दिए हैं। IS-अनुरूप ड्रॉइंग, ईमानदार टनेज अनुमान और समय पर साइट पर क्रेन। इस क्षेत्र में दुर्लभ।" },
        { role: "डायरेक्टर, लॉजिस्टिक्स वेयरहाउसिंग", quote: "12kW लेज़र जॉब-वर्क वास्तव में तेज़ है। जटिल ब्रैकेट स्पेक अनुसार कटे, कोई री-वर्क नहीं। अब हमारे डिफ़ॉल्ट फैब्रिकेटर हैं।" },
      ],
    },
    footer: {
      desc: "IS मानकों के अनुसार भारी और संरचनात्मक धातु फैब्रिकेशन। नागपुर, चंद्रपुर, अमरावती, वर्धा और यवतमाल में औद्योगिक, कृषि और कमर्शियल ग्राहकों की सेवा।",
      quickWhatsapp: "त्वरित WhatsApp पूछताछ",
      navigate: "नेविगेट",
      workshop: "कार्यशाला",
      links: { services: "सेवाएं", capabilities: "क्षमताएं", portfolio: "पोर्टफोलियो", quality: "गुणवत्ता मानक", quote: "कोटेशन लें" },
      rights: "सर्वाधिकार सुरक्षित।",
    },
  },

  mr: {
    nav: { services: "सेवा", capabilities: "क्षमता", portfolio: "पोर्टफोलिओ", quality: "गुणवत्ता", contact: "संपर्क" },
    brandSub: "स्टील · संरचना · विदर्भ",
    cta: { whatsapp: "WhatsApp", rapidQuote: "त्वरित कोटेशन", requestEstimation: "प्रकल्प अंदाज मिळवा", viewProjects: "पूर्ण प्रकल्प पहा", whatsappUs: "WhatsApp करा" },
    labels: { services: "मुख्य सेवा", capabilities: "कार्यशाळा आणि यंत्रसामग्री", portfolio: "पूर्ण झालेले प्रकल्प", quote: "त्वरित कोटेशन आणि RFQ", trust: "स्थानिक उपस्थिती आणि विश्वास" },
    hero: {
      eyebrow: "जड अभियांत्रिकी · स्थापना 2010",
      madeInIndia: "अभिमानाने भारतात निर्मित",
      lines: ["जड आणि", "संरचनात्मक धातू", "फॅब्रिकेशन", "संपूर्ण विदर्भात"],
      tagline: "मजबूत स्टील · विश्वासाचे बांधकाम",
      sub: "टर्नकी प्री-इंजिनीअर्ड बिल्डिंग (PEB), औद्योगिक शेड, प्रेशर व्हेसल, स्टोरेज टँक आणि कस्टम शीट-मेटल उपाय — IS मानकांनुसार तयार.",
      live: "// नागपूर कार्यशाळा · लाइव्ह",
      scroll: "स्क्रोल",
    },
    metrics: ["वर्षांचा अनुभव", "प्रकल्प पूर्ण", "& MSME प्रमाणित", "अनुरूप"],
    services: {
      heading: ["एका ब्रॅकेटपासून", "50-टन", "संरचनांपर्यंत"],
      sub: "एकाच MIDC छताखाली चार एकात्मिक विभाग — डिझाइन, वेल्डिंग आणि स्पेकनुसार पाठवणी.",
      items: [
        { title: "औद्योगिक आणि PEB शेड", desc: "MIDC झोनसाठी टर्नकी फॅक्टरी शेड आणि लॉजिस्टिक्स वेअरहाऊस — फाउंडेशन बोल्टपासून रूफिंग शीटपर्यंत.", tags: ["फॅक्टरी शेड", "PEB", "वेअरहाऊस"] },
        { title: "जड औद्योगिक फॅब्रिकेशन", desc: "स्टोरेज टँक, सायलो, हॉपर आणि IS मानकांनुसार प्रेशर व्हेसल.", tags: ["टँक", "सायलो", "प्रेशर व्हेसल"] },
        { title: "कृषी आणि अ‍ॅग्रो-प्रोसेसिंग", desc: "कापूस जिनिंग च्यूट, कन्व्हेयर सिस्टीम आणि विदर्भाच्या कृषी पट्ट्यासाठी धान्य साठवण संरचना.", tags: ["जिनिंग च्यूट", "कन्व्हेयर", "धान्य साठवण"] },
        { title: "कमर्शियल आणि लेझर कटिंग", desc: "मेझानाइन फ्लोअर, संरचनात्मक जिने आणि अचूक CNC लेझर कटिंग जॉब-वर्क.", tags: ["मेझानाइन", "जिने", "CNC लेझर"] },
      ],
    },
    machinery: {
      heading: ["जड कामे हाताळणारी", "क्षमता"],
      sub: "22,000 चौ. फूट कव्हर्ड शॉप फ्लोअर · IS-प्रमाणित प्रक्रिया · इन-हाऊस QA",
      items: [
        { name: "CNC फायबर लेझर कटिंग", detail: "25mm MS प्लेटपर्यंत हाय-स्पीड अचूक कटिंग" },
        { name: "4-रोल हेवी प्लेट बेंडिंग", detail: "3m रुंदीपर्यंत शेल आणि कोनचे हायड्रॉलिक रोलिंग" },
        { name: "MIG / TIG / SMAW वेल्डिंग", detail: "सर्व प्रोसेस स्टेशनवर प्रमाणित वेल्डर" },
        { name: "ओव्हरहेड EOT क्रेन", detail: "जड असेंब्लीसाठी ट्विन-गर्डर हाताळणी" },
      ],
    },
    gallery: {
      heading: ["संपूर्ण विदर्भात", "पूर्ण"],
      tabs: { all: "सर्व", sheds: "औद्योगिक शेड", tanks: "स्टोरेज टँक", commercial: "कमर्शियल" },
      actualWork: "प्रत्यक्ष काम",
      titles: {
        101: "स्टील रूफिंग ट्रस संरचना", 102: "रूफटॉप शेड - साइटवर उभारणी", 103: "टेरेस शेड आणि अ‍ॅल्युमिनियम ग्लेझिंग",
        104: "कस्टम MS स्टील बेंच", 105: "स्टेनलेस स्टील खिडकी ग्रिल", 1: "PEB फॅक्टरी शेड", 2: "SS स्टोरेज टँक फार्म",
        3: "CNC लेझर जॉब-वर्क", 4: "लॉजिस्टिक्स वेअरहाऊस", 5: "सिमेंट सायलो क्लस्टर", 6: "संरचनात्मक जिना",
        7: "प्रेशर व्हेसल युनिट", 8: "मेझानाइन फ्लोअर",
      },
    },
    quote: {
      heading: ["मिळवा त्वरित", "अंदाज"],
      sub: "तुमची ड्रॉइंग किंवा गरजा शेअर करा. आमचे अंदाजक टनेज, कालमर्यादा आणि ₹ मध्ये पारदर्शक किंमत (प्रति किलो / प्रति चौ. फूट) सह उत्तर देतात — सहसा एका कामकाजाच्या दिवसात.",
      contact: { call: "कॉल / WhatsApp", email: "ईमेल", workshop: "कार्यशाळा" },
      fields: { name: "पूर्ण नाव *", company: "कंपनीचे नाव", phone: "फोन नंबर *", location: "प्रकल्प ठिकाण / MIDC", service: "सेवा प्रकार", estimate: "अंदाजे टनेज / क्षेत्रफळ (चौ. फूट)", drawing: "इंजिनीअरिंग ड्रॉइंग (CAD / PDF)", message: "संदेश" },
      ph: { name: "राजेश देशमुख", company: "विदर्भ अ‍ॅग्रो प्रा. लि.", phone: "76662 88210", location: "बुटीबोरी MIDC, नागपूर", estimate: "उदा. 45 टन / 12,000 चौ. फूट", upload: "ड्रॉइंग अपलोड करा (कमाल 25MB)", message: "तुमच्या प्रकल्पाची व्याप्ती, स्टील ग्रेड, डिलिव्हरी कालमर्यादा सांगा..." },
      services: ["औद्योगिक शेड", "PEB", "हेवी व्हेसल", "लेझर कटिंग", "इतर"],
      submit: "त्वरित पुनरावलोकनासाठी RFQ पाठवा",
      submitting: "पाठवत आहे...",
      errRequired: "नाव आणि फोन नंबर आवश्यक आहेत.",
      okToast: "RFQ पाठवला — आमची इंजिनीअरिंग टीम लवकरच पुनरावलोकन करेल.",
      errToast: "काहीतरी चूक झाली. कृपया पुन्हा प्रयत्न करा किंवा WhatsApp करा.",
      successTitle: "RFQ मिळाला",
      successBody: (n, p) => `धन्यवाद, ${n}. आमची इंजिनीअरिंग टीम तुमच्या विनंतीचे पुनरावलोकन करत आहे आणि ${p} वर संपर्क करेल.`,
      another: "आणखी एक पाठवा",
    },
    trust: {
      heading: ["प्लांट मॅनेजर्सचा विश्वास", "संपूर्ण पट्ट्यात"],
      coverage: "सेवा क्षेत्र",
      coverageNote: "// विदर्भातील सर्व जिल्ह्यांत डिस्पॅच आणि साइटवर उभारणी टीम उपलब्ध.",
      mapPin: "डालडा कंपनी चौक · नागपूर मुख्यालय",
      madeInIndia: "भारतात निर्मित",
      since: "2010 पासून विदर्भाच्या सेवेत",
      pricing: "पारदर्शक ₹/किलो आणि ₹/चौ. फूट अंदाज",
      testimonials: [
        { role: "प्लांट मॅनेजर, अ‍ॅग्रो प्रोसेसिंग युनिट", quote: "निधीने आमचा स्टोरेज सायलो क्लस्टर वेळेच्या तीन आठवडे आधी पूर्ण केला. वेल्डिंग गुणवत्ता पहिल्याच थर्ड-पार्टी तपासणीत पास झाली." },
        { role: "इन्फ्रास्ट्रक्चर कंत्राटदार", quote: "आम्ही आतापर्यंत त्यांना चार PEB शेड दिले आहेत. IS-अनुरूप ड्रॉइंग, प्रामाणिक टनेज अंदाज आणि वेळेवर साइटवर क्रेन. या भागात दुर्मिळ." },
        { role: "संचालक, लॉजिस्टिक्स वेअरहाऊसिंग", quote: "12kW लेझर जॉब-वर्क खरोखर वेगवान आहे. गुंतागुंतीचे ब्रॅकेट स्पेकनुसार कापले, री-वर्क नाही. आता आमचे डिफॉल्ट फॅब्रिकेटर." },
      ],
    },
    footer: {
      desc: "IS मानकांनुसार जड आणि संरचनात्मक धातू फॅब्रिकेशन. नागपूर, चंद्रपूर, अमरावती, वर्धा आणि यवतमाळमध्ये औद्योगिक, कृषी आणि कमर्शियल ग्राहकांची सेवा.",
      quickWhatsapp: "त्वरित WhatsApp चौकशी",
      navigate: "नेव्हिगेट",
      workshop: "कार्यशाळा",
      links: { services: "सेवा", capabilities: "क्षमता", portfolio: "पोर्टफोलिओ", quality: "गुणवत्ता मानके", quote: "कोटेशन घ्या" },
      rights: "सर्व हक्क राखीव.",
    },
  },
};
